import axios from "axios";
import { useMutation } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { ITeamMembers } from "../types";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_REMOVE_TEAM_MEMBERS = "remove-team-member";


const removeData = async (props: { user_id: string, token: string }): Promise<ITeamMembers[]> => {
    const url = `${END_POINT.BASE_URL}/v1/remove-team-member`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${props.token}`,
        },
    };

    const res = await axios.post(url, { user_id: props.user_id }, config);

    const data: ITeamMembers[] = res.data;
    return data;
};


export const useRemoveTeamMember = () => {
    const { token } = useGetUserInfo();

    const mutation = useMutation(
        (user_id: string) => removeData({ user_id, token }),
        {
            onError: (err: any) => {
                console.error("Error removing member:", err);
            },
            onSuccess: (data) => {
                console.log("Successfully removed team member:", data);
            },
        }
    );

    return mutation;
};